module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7varOE/images/cover.jpg?1706297447657",
      "alt": "This image is the cover for the book BEF in 1917, Images of War"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("BEF in 1917, Images of War\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This new volume in the long-running Images of War series features the actions of the British Army at Passchendaele. The book is comprised of rare photographs illustrating the years of fighting on the northern sector of the Ypres salient, which finally culminated in the capture of the ridge at Passchendaele, accompanied by a powerful text written by Official War Correspondent Philip Gibbs, who was an eyewitness to the events. Photographs from the battlefield illustrate the terrible conditions, which the British forces on the battlefield endured in the notorious engagement, which has become synonymous with mud and squalor.This book incorporates a wide range of images, encompassing the actions of the British infantry and their supporting artillery. Also featured are images which depict the almost incomprehensible state of the waterlogged trenches. Portraits of the British troops are contrasted with German prisoners of war and the endless battle to get the supply columns through to the front.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bob Carruthers\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0